export default __webpack_public_path__ + "static/media/runnable.8585895d.svg";